import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { LinesEditorComponent } from '../../../../../components';
import { ColDef, IRowNode } from '@ag-grid-community/core';
import { FieldTypes } from '@digiwall/ag-grid';
import { LocalizationService } from '@abp/ng.core';

@Component({
  selector: 'document-return-note-to-credit-note-grid',
  templateUrl: './return-note-to-credit-note-grid.component.html',
  imports: [LinesEditorComponent],
})
export class ReturnNoteToCreditNoteGridComponent implements AfterViewInit {
  @ViewChild('lineGrid') lineGrid: LinesEditorComponent;

  @Input() currentReturnNoteId: string;
  @Input() set lines(value) {
    this._lines = value;
  }

  @Output() selectionChange = new EventEmitter();

  _lines: any[];

  public get lines() {
    return this._lines;
  }

  columnDefs: ColDef[] = [
    {
      field: 'displayNumber',
      headerName: this.localizationService.instant('::Number'),
      type: FieldTypes.String,
    },
    {
      field: 'description',
      headerName: this.localizationService.instant('::Description'),
      type: FieldTypes.String,
    },
    {
      field: 'documentDate',
      headerName: this.localizationService.instant('Doc::CustomerQuote:DocumentDate'),
      type: FieldTypes.Date,
    },
    {
      field: 'totalAmount',
      headerName: this.localizationService.instant('Doc::TotalHTVA'),
      type: FieldTypes.Currency,
    },
    {
      field: 'salesPerson',
      headerName: this.localizationService.instant('::Responsible'),
      type: FieldTypes.String,
    },
  ];

  constructor(private localizationService: LocalizationService) {}

  ngAfterViewInit(): void {
    this.lineGrid.grid.grid.api.setGridOption('onFirstDataRendered', event => {
      const nodesToSelect: IRowNode[] = [];
      event.api.forEachNode(node => {
        if (node.data.id == this.currentReturnNoteId) {
          nodesToSelect.push(node);
        }
      });
      event.api.setNodesSelected({ nodes: nodesToSelect, newValue: true });
    });

    this.lineGrid.grid.grid.api.setGridOption('onRowSelected', event => {
      if (!event.node.isSelected() && event.data.id == this.currentReturnNoteId) {
        event.node.setSelected(true);
      }
    });

    this.lineGrid.grid.grid.api.setGridOption('onSelectionChanged', event => {
      this.selectionChange.emit(event.api.getSelectedNodes().map(node => node.data));
    });
  }
}
